import FlashcardsDashboardPage from "@/pages/flashcards/dashboard"
import FlashcardGamePage from "@/pages/flashcards/game"
import SpecialDeckPage from "@/pages/flashcards/special-deck"
import { type RouteObject } from "react-router-dom"

const routes: RouteObject = {
  path: "flashcards",
  children: [
    {
      index: true,
      element: <FlashcardsDashboardPage />,
    },
    {
      path: "special-deck",
      element: <SpecialDeckPage />,
    },
    {
      path: ":flashcardId",
      element: <FlashcardGamePage />,
    },
  ],
}

export default routes
